import { render, staticRenderFns } from "./ErrorsList.vue?vue&type=template&id=9375784a&scoped=true"
import script from "./ErrorsList.vue?vue&type=script&lang=js"
export * from "./ErrorsList.vue?vue&type=script&lang=js"
import style0 from "./ErrorsList.vue?vue&type=style&index=0&id=9375784a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9375784a",
  null
  
)

export default component.exports